<template>
    <div :class="{'isBE' : isBE, 'isNCH': isNCH }">
        <div v-show="isBE" style="clear:both"></div>
        <div class="showmore-divider">
            <div class="showmore-text" @click.prevent="clickLink()">
                {{!link_clicked ? strings.moreOptions : strings.lessOptions}}
                <font-awesome-icon class="collapse-trigger-icon" :icon="['fas', link_clicked ? 'chevron-up' : 'chevron-down']" />
            </div>
        </div>
        <div v-show="link_clicked">
            <div  class="more-options-block" v- style="min-height: 20px;">
                <div class="field-container discount-code-wrapper">
                    <span class="form__label"> {{ strings.add_discount_code }} </span>
                    <!-- <input  v-on:blur="applyDiscountCodeOnBlur($event.target.value)" type="text" class="form__input" :placeholder="strings.code" v-model="_s_code" > -->
                    <input type="text" class="form__input discount-code-input" :placeholder="strings.code" v-model="_s_code" >
                    <button type="submit" class="button button--success" @click.prevent="applyDiscountCode()">{{ strings.apply }}</button>
                    <div style="clear:both;"></div>
                </div>

                <label class="field-container"> 
                    <span class="form__label"> {{ strings.seatingorder }} </span>
                    <select name="length" class="form__input form__select" v-model="s_layout">
                      <option v-for="so in seatingOrderList" :value="so.value" :key="so.id">{{ translateLayout(so.value) }}</option>
                    </select>
                </label>

                <label class="field-container last-field"> 
                    <span class="form__label"> {{ strings.showRates }} </span>
                    <select :disabled="disabledShowRatesFilter" name="length" class="form__input form__select" v-model="showRatesFilter">
                      <option value="all">{{ strings.all }}</option>
                      <option value="roomRental">{{ strings.meetingRoomRental }}</option>
                      <option value="packages">{{ strings.packages }}</option>
                    </select>
                </label>
            </div>
            <MoreOptionsErrorBlock v-if="!isBE" />
        </div>
    </div>
</template>

<script>
import MoreOptionsErrorBlock from './MoreOptionsErrorBlock';
import * as _ from 'lodash';

export default {
    components: {
      MoreOptionsErrorBlock
    },
    data () {
        return {
            _s_code: '',
            _discount_code : '',
            link_clicked : false,
        }
    },
    mounted() {
        this._s_code = this.$store.state.discount_code;
        
        let optionSelectedCookie = this.$cookie.get('_pref_index') == 'package_index'

        if (optionSelectedCookie) {
            this.link_clicked = true
            this.showRatesFilter = 'packages'
        }
    },
    computed: {
        isMoreThanOneDay(){
            return this.$store.state.isMoreThanOneDay;
        },
        packageInfo(){
            return this.$store.state.packageInfo;
        },
        disabledShowRatesFilter(){
            return this.packageInfo.length === 0
        },
        venueHasDiscountCode(){
            return this.$store.state.venueInfo.venue_has_discount_code
        },
        isBE() {
            return this.$store.state.isBE;
        },
        haveDiscountCode() {
            if(this.$store.state.discount_code){
                return true;
            } else {
                return false;
            }
        },
        isNCH(){
            return this.$store.state.isNCH;
        },
        isOpera(){
            return this.$store.state.isOpera;
        },
        isLoading(){
            return this.$store.state.discountCodeLoading;
        },
        strings() {
            return this.$store.state.strings;
        },
        s_code: {
            get: function () {
                this._discount_code = this.$store.state.discount_code;
                return this.$store.state.discount_code;
            },
            set: function (code) {
                this._s_code = code;
            }
        },
        currentTab() {
            return this.$store.state.currentTab;
        },
        discount_code() {
            return this.$store.state.discount_code;
        },
        discPriceErrorShouldShow() {
            return this.$store.state.discPriceErrorShouldShow;
        },
        seatingOrderList() {
            if(this.$store.state.useNewCheckoutPage){
            return this.$store.state.seatingOrderList.filter( el => {
                return el.value != "401";
            });
            }
            return this.$store.state.seatingOrderList;
        },
        s_layout: {
            get: function () {
                if(this.$store.state.currentTab == 'room'){
                    return this.$store.state.selectedLayout
                } else {
                    return this.$store.state.selectedLayoutinPackage
                }
            },
            set: _.debounce(function (selectedLayout) {
                this.$store.commit('setSelectedLayout', selectedLayout);
                this.$store.commit('setSelectedLayoutinPackage', selectedLayout);
                this.$store.dispatch('fetchPackageAndRoom', {
                    venueID: this.$store.state.venueInfo.id
                });
            }, 300)
        },
        showRatesFilter: {
            get: function() {
                return this.$store.state.showRatesFilter;
            },
            set: function(value) {
                this.$store.commit('setShowRatesFilter', value)
            }
        }
    },
    methods: {
        clickLink(){
            this.link_clicked = !this.link_clicked;
        },
        translateLayout(layoutCode) {
            return this.strings?.layouts[layoutCode];       
        },
        applyDiscountCodeOnBlur(value){
            if(value != this._discount_code){
                this._discount_code = value;
                this.$store.commit('setDiscountCode', this._discount_code);

                // Should set to cookie as well.
                this.$cookie.set('discount_code', this._discount_code);

                if(this.currentTab == 'room'){
                    this.$store.dispatch('checkAvailabilityandPrices', {fromDiscountCode: true});
                } else {
                    this.$store.dispatch('checkAvailabilityandPricesfromPackage', {fromDiscountCode: true});
                }
            }
        },
        applyDiscountCode(){
            if(typeof this._s_code == 'undefined'){
                this._s_code = '';
            }
            this._discount_code = this._s_code;
            this.$store.commit('setDiscountCode', this._discount_code);
            this.$cookie.set('discount_code', this._discount_code);

            this.$store.dispatch('fetchPackageAndRoom', {venueID: this.$store.state.venueInfo.id});
        }
        
    },
    watch: {
        discount_code(code) {
            this._discount_code = code;
        },
        packageInfo(packages) {
            if (this.$store.state.packagesReady && packages.length === 0) {
                this.$store.commit('setShowRatesFilter', "all")
            }
        }
    }
}
</script>

<style scoped>
    .more-options-block{
        display: flex;
        width: 100%;
    }
    .isBE .more-options-block{
        margin-top:10px;
        margin-right:20px;
    }
    button {
        background-color: #0055a9;
        border: 1px solid #0055a9;
        width: 38%;
        margin-left: 2%;
        margin-top: 3px;
        max-height: 35px;
        min-height: 35px;
        line-height: 10px;
        width: 20%;
    }
    .more-options-block a, .more-options-block a:visited{
        float: right;
        color: black;
        text-decoration: underline;
    }

    .more-options-block p {
        color: black;
        font-style: italic;
    }
    .discount-code-wrapper .v-spinner{
        float:none;
    }
    .discount-code-wrapper button{
        max-height:40px;
    }
    .discount-code-wrapper .v-pulse{
        width:14px!important;
        height: 14px!important;
    }
    .more-options-block .helptext{
        margin-bottom: 0px;
        font-size: 12px;
        padding-left: 5px;
            font-style: normal;
    }
    .discount-code-wrapper{
        margin-left:5px;
    }
    .discount-code-error{
        color:red;
        margin-bottom: 0px;
        margin-top: 20px;    
    }
    .isBE .discount-code-wrapper{
        margin-left:0px;
    }
    .isBE .discount-code-wrapper button {
        margin: 0px;
        margin-left: 5px;
        height: 34px;
        width: calc(30% - 5px);
        padding: unset;
    }
    .isNCH .discount-code-wrapper button{
        background-color: #00aa50!important;
        border: 1px solid #00aa50!important;
    }
    .showmore-divider {
        margin: 30px 0;
        height: 1px;
        background-color: #e0e0e0;
        position: relative;
    }
    .showmore-text {
        text-align: center;
        position: absolute;
        left: calc(50% - 60px);
        background: white;
        top: -7px;
        font-size: 12px;
        width: 120px;
    }
    .showmore-text:hover {
        cursor: pointer;
    }
    .field-container {
        width: 32%;
        margin-right: 2%;
    }
    .form__label {
        display: block;
        margin-bottom: .5em;
        font-weight: 700;
        font-size: 12px;
        color: #323232;
        height: 22px;
    }
    .discount-code-input {
        width: 70%;
        display: inline;
        margin-top: 0px;
    }
    .last-field {
        margin-right: 0px;
    }
    .collapse-trigger-icon {
        width: 10px;
        height: 10px;
        color: #505050;
        margin-left: 3px;
    } 
    #venue .form.aside__basics.horizontal-form .form__label {
        color: #323232;
    }
    @media screen and (max-width: 640px) {
        .isNCH .discount-code-wrapper button{
            margin-top: 5px;
        }
        .field-container {
            width: 100%;
            margin-bottom: 15px;
        }
        .more-options-block {
            display: block;
        }
    }
</style>
